import React,{useState,useEffect} from 'react'
import {useSelector} from 'react-redux'
import {baseURL, Encrypt, headers} from '../../Config'
import Skeleton from 'react-loading-skeleton';
import ParentDashboardSideBar from '../../Components/ParentDashboardSideBar'
import ParentDashboardNavbar from '../../Components/ParentDashboardNavbar'
import DashboardNotesCard from '../../Components/DashboardNotesCard'
import videoImage from '../../images/VideoImage.png'
import { toast } from 'react-toastify'
import {Link} from 'react-router-dom'
import './CSS/InstructionsAndGuidencePage.css'

export default function InstructionsAndGuidencePage() {

    const [windowWidth,setWindowWidth] = useState(window.innerWidth)
    const [loader,setLoader] = useState([{},{},{},{}])
    const [isLoaded,setIsLoaded] = useState(false)
    const [videos,setVideos] = useState([])
    const [notes,setNotes] = useState([])

    const sidebarWidth = useSelector(data => data.SidebarReducer.width)

    useEffect(()=>{
        window.addEventListener('resize',()=>{
            const windowWidth = window.innerWidth;
            setWindowWidth(windowWidth)
        })

        const dt = JSON.parse(localStorage.getItem('bx_user_token'))
        if(dt){
                fetch(baseURL + '/api/get-instructions-and-guidance',{
                    headers:{'authorization':'Bearer ' + dt.accessToken}
                })
                .then(res=>res.json())
                .then(res2=>{
                    if(res2.code === 'Error'){
                        toast.error('Error',{toastId:'inst-guide-parent-id1'})
                        setIsLoaded(true)
                    }
                    else{
                        const videos = res2.message&&res2.message.filter(dt=>dt.type == 0)
                        const notes = res2.message&&res2.message.filter(dt=>dt.type == 1)
                        setVideos(videos)
                        setNotes(notes)
                        setIsLoaded(true)
                    }
                })
            }
    },[])

    return (
        <div className="parent-dashboard-instructions-and-guidence">
            <ParentDashboardSideBar active="home" />
            <div style={{marginLeft:windowWidth > 1024 && sidebarWidth}}>
                <ParentDashboardNavbar />
                <div className="parent-dashboard-instructions-and-guidence-body">
                    <h1 style={{fontFamily:'CocoSharp bold'}}>Instructions & guidance</h1>
                    <div style={{width:'100%',marginTop:72}}>
                        <h2 style={{fontFamily:'CocoSharp bold'}} className="mb-0">Pre-Recorded Videos</h2>
                        <div className="parent-dashboard-instructions-and-guidence-videos">
                            {
                                isLoaded ?
                                    videos.length > 0 ?
                                        videos.map(dt=>{
                                            return <VideoCard 
                                                        Id={dt.Id}
                                                        src={videoImage}
                                                        thumbnail={dt.thumbnail}
                                                        title={dt.title}
                                                        file={dt.file}
                                                        description={dt.description}
                                                        videoCardContainerClass="video-continer" 
                                                    />
                                        })
                                    :
                                        <h4 style={{color:'lightgray'}}>No Data</h4>
                                        
                                :
                                    loader.map(dt=>{
                                        return <Skeleton className="video-continer" />
                                    })
                            }
                        </div>
                    </div>
                    <div style={{width:'100%',marginTop:30}}>
                        <h2 style={{fontFamily:'CocoSharp bold'}} className="mb-0">Instruction Notes</h2>
                        <div className="parent-dashboard-instructions-and-guidence-notes-section">
                            {
                                isLoaded ?
                                    notes.length > 0 ?
                                        notes.map((dt,i)=>{
                                            return(
                                                <DashboardNotesCard 
                                                    index={i+1} 
                                                    title={dt.title}
                                                    description={dt.description}
                                                    file={dt.file}
                                                />
                                            )
                                        })
                                    :
                                        <h4 style={{color:'lightgray'}}>No Data</h4>
                                    
                                :
                                    loader.map(dt=>{
                                        return <Skeleton width={200} height={200} style={{marginTop:20,borderRadius:15,marginRight:20}} />
                                    })
                            }
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}


const VideoCard = (props) => {
    return(
        <div>
            <div className={props.videoCardContainerClass} style={{backgroundImage:`url(${props.thumbnail})`,backgroundPosition:'center',backgroundSize:'cover'}}>
                <Link to={{pathname:`/watch-video/${Encrypt(`${JSON.stringify({title:props.title,des:props.description,url:props.file,comp:0})}`)}`}}>
                    <img src={props.src} style={{objectFit:'cover'}} />
                </Link>
            </div>
            <p style={{fontSize:16,fontFamily: 'CocoSharp regular',marginTop:5,marginLeft:5}}>{props.title&&props.title.length > 24 ? props.title.slice(0,24) + '...' : props.title}</p>
        </div>
    )
}